import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FollowWxDialog',
  setup(__props, { expose: __expose }) {

const dialog = ref<Boolean>(false) // 弹框状态
const qrcode = ref<String>('https://image-oss.dangaoss.cn/rests/rests_20230613101214_637.png') // 二维码图片地址

const openFollowDialog = () => {
    dialog.value = true
}

// 暴露方法
__expose({
    openFollowDialog
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "wx-dialog",
    title: "关注微信公众号",
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "请扫码关注蛋糕叔叔微信公众号", -1)),
      _createVNode(_component_el_image, {
        class: "qrcode",
        src: qrcode.value,
        fit: "contain"
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})